module.exports = "<div id=\"complexGA\" class=\"graph\"></div>\r\n"